export const REJECTED_WORDS = [
    "shit",
    "shitting",
    "shitty",
    "shitty",
    "fuck",
    "fucking",
    "fuckin",
    "fucked",
    "fucker",
    "fucking",
    "fucked",
    "fucker",
    "fucking",
    "fucked",
    "fucker",
    "bitch",
    "bitching",
    "bitchy",
    "bitchy",
    "cunt",
    "cunting",
    "cuntish",
    "cuntish",
    "bastard",
    "bastarding",
    "bastardy",
    "bastardy",
    "twat",
    "twatting",
    "twatty",
    "twatty",
    "wanker",
    "wanking",
    "wanky",
    "wanky",
    "wank",
    "wanking",
    "wanky",
    "dick",
    "dicking",
    "dicky",
    "dicky",
    "dickhead",
    "dickheads",
    "dickheads",
    "dickhead",
    "dickheads",
    "dickheads",
    "dickhead",
    "tits",
    "titting",
    "titty",
    "titty",
]

const uniqueRejectedWords = [...new Set(REJECTED_WORDS.map((word) => word.toLowerCase()))]

export const messageContainsRejectedWord = (text) => {
    if (!text?.trim()) return false

    const normalized = text.toLowerCase()
    return uniqueRejectedWords.some((word) => {
        const pattern = new RegExp(`\\b${word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i')
        return pattern.test(normalized)
    })
}